"use strict";

var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var penpal_1 = __importDefault(require("penpal"));

var eventemitter3_1 = __importDefault(require("eventemitter3"));

var moment_1 = __importDefault(require("moment"));

var is_buffer_1 = __importDefault(require("is-buffer"));

var utils_1 = require("./utils");

var AuthereumProvider_1 = __importDefault(require("./AuthereumProvider"));

var config_1 = require("./config");

var Notifier_1 = __importDefault(require("./Notifier"));

var version_1 = __importDefault(require("./version")); // Serialize object for postMessage to iframe.
// Converts references to values.


var serializeMessageObj = function serializeMessageObj(obj) {
  var tx = {};

  for (var k in obj) {
    var v = obj[k];

    if (typeof v === 'object' && v.toString === 'function') {
      v = v.toString('hex');
    }

    tx[k] = v;
  }

  return tx;
};

var Authereum =
/*#__PURE__*/
function (_eventemitter3_1$defa) {
  _inherits(Authereum, _eventemitter3_1$defa);

  function Authereum(config) {
    var _this;

    _classCallCheck(this, Authereum);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Authereum).call(this));
    _this.blockedPopupRedirect = true;
    _this.notificationsMap = {}; // NOTE: to prevent pop-ups from being blocked, there must be no awaits from
    // click to window.open, meaning value lookups must be cached before the
    // login method is called.

    _this.login = utils_1.throttle(function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var account;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.tilReady();

              case 2:
                if (this.cachedIsAuthenticated) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return this.signLoginKeyRequest(this.cachedLoginKeyAddress);

              case 5:
                return _context.abrupt("return", this.getAuthenticatedAccount());

              case 8:
                this.notifier.notify('success', 'You are logged into Authereum', {
                  timeout: 5000
                });

              case 9:
                _context.next = 11;
                return this.getAuthenticatedAccount();

              case 11:
                account = _context.sent;
                return _context.abrupt("return", account);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }, 250);
    _this.signWithDappKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.tilReady();

              case 2:
                return _context2.abrupt("return", this.handleError(this.childIframeConnection.signWithLoginKey(message)));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }, 250);
    _this.signWithLoginKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.signWithLoginKey()` is deprecated. Use `authereum.signWithDappKey()` instead.');
                return _context3.abrupt("return", this.signWithDappKey(message));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }, 250);
    _this.signTypedMessageWithDappKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.tilReady();

              case 2:
                return _context4.abrupt("return", this.handleError(this.childIframeConnection.signTypedMessageWithLoginKey(message)));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }, 250);
    _this.signMessageWithAdminKey = utils_1.throttle(function (message) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var url, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.tilReady();

              case 2:
                url = this.getSignWithAdminKeyUri(message);
                _context5.next = 5;
                return this.openPopupOrRedirect(url);

              case 5:
                result = _context5.sent;
                return _context5.abrupt("return", result.signature);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }, 250);
    _this.signTransactionWithLoginKey = utils_1.throttle(function (tx) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.tilReady();

              case 2:
                return _context6.abrupt("return", this.handleError(this.childIframeConnection.signTransactionWithLoginKey(serializeMessageObj(tx), true)));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }, 250);
    _this.sendTransaction = utils_1.throttle(function (tx) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.tilReady();

              case 2:
                return _context7.abrupt("return", this.handleError(this.childIframeConnection.executeLoginKeyMetaTx(serializeMessageObj(tx))));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }, 250);

    _this.setConfig(config);

    _this.setupNotifier();

    return _this;
  } // NOTE: keep this sync


  _createClass(Authereum, [{
    key: "setConfig",
    value: function setConfig(config) {
      if (typeof config === 'string') {
        var network = config;
        this.networkName = (network || '').trim().toLowerCase();

        if (['mainnet', 'ropsten', 'rinkeby', 'kovan', 'goerli'].includes(this.networkName)) {
          this.apiUri = config_1.defaultConfig.apiUri(this.networkName);
          this.rpcUri = config_1.defaultConfig.rpcUri(this.networkName);
          this.webUri = config_1.defaultConfig.webUri(this.networkName);
          this.xsUri = config_1.defaultConfig.xsUri(this.networkName);
        } else if (config === 'localhost') {
          this.apiUri = 'http://localhost:4000';
          this.rpcUri = 'https://kovan.rpc.authereum.com';
          this.webUri = 'http://localhost:3000';
          this.xsUri = 'http://localhost:3002';
          this.networkName = 'kovan';
        } else {
          throw new Error('Unsupported network');
        }
      } else {
        config = config || {};
        this.networkName = config.networkName || 'mainnet';
        this.rpcUri = config.rpcUri || config_1.defaultConfig.rpcUri(this.networkName);
        this.webUri = config.webUri || config_1.defaultConfig.webUri(this.networkName);
        this.xsUri = config.xsUri || config_1.defaultConfig.xsUri(this.networkName);
        this.disableNotifications = config.disableNotifications;

        if (typeof config.blockedPopupRedirect === 'boolean') {
          this.blockedPopupRedirect = config.blockedPopupRedirect;
        }
      }

      this.networkId = config_1.defaultConfig.networkId(this.networkName);

      if (config.redirectUri) {
        this.redirectUri = config.redirectUri;
      } else {
        this.redirectUri = window.location.href;
      }

      this.cacheReady = false;
      this.iframeReady = false;
      this.readyEmitted = false;
      this._widgetEnabled = false;
      this.iframeStyle = {
        width: 0,
        height: 0,
        top: 0,
        left: 0
      };
      this.redirectUri = this.redirectUri || window.location.href;
      this.provider = new AuthereumProvider_1.default(this);
      this.connectToChildIframe();
      this.setupCache();
      this.setupResizeListener();
      this.emitReadyEvent();
    }
  }, {
    key: "setupCache",
    value: function setupCache() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Promise.all([this.cacheLoginKeyAddress(), this.cacheIsAuthenticated(), this.cacheAccountAddress()]);

              case 2:
                this.cacheReady = true;

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "resetCache",
    value: function resetCache() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.setupCache();

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "setupNotifier",
    value: function setupNotifier() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.tilDomReady();

              case 2:
                this.notifier = new Notifier_1.default({
                  networkId: this.networkId,
                  disableNotifications: this.disableNotifications
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "setupResizeListener",
    value: function setupResizeListener() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                window.addEventListener('resize', utils_1.debounce(function (event) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee11() {
                    var size;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return this.tilIframeReady();

                          case 2:
                            if (!this.childIframeConnection.onResize) {
                              _context11.next = 7;
                              break;
                            }

                            _context11.next = 5;
                            return this.getWindowSize();

                          case 5:
                            size = _context11.sent;
                            this.childIframeConnection.onResize(size);

                          case 7:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this);
                  }));
                }, 100));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    }
  }, {
    key: "cacheLoginKeyAddress",
    value: function cacheLoginKeyAddress() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var loginKey;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.tilIframeReady();

              case 2:
                _context13.next = 4;
                return this.childIframeConnection.getOrCreateLoginKey();

              case 4:
                loginKey = _context13.sent;
                this.cachedLoginKeyAddress = loginKey.publicAddress;

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "cacheAccountAddress",
    value: function cacheAccountAddress() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.tilIframeReady();

              case 2:
                _context14.next = 4;
                return this.childIframeConnection.getAccountAddress();

              case 4:
                accountAddress = _context14.sent;
                this.cachedAccountAddress = accountAddress;

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "cacheIsAuthenticated",
    value: function cacheIsAuthenticated() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.tilIframeReady();

              case 2:
                _context15.next = 4;
                return this.isAuthenticated();

              case 4:
                this.cachedIsAuthenticated = _context15.sent;

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.authenticate()` is deprecated. Use `authereum.login()` instead.');
                return _context16.abrupt("return", this.login());

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.tilIframeReady();

              case 2:
                return _context17.abrupt("return", this.handleError(this.childIframeConnection.isAuthenticated()));

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        var res;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.tilReady();

              case 2:
                _context18.next = 4;
                return this.childIframeConnection.logout();

              case 4:
                res = _context18.sent;
                this.resetCache();
                this.emit('logout', {});
                return _context18.abrupt("return", res);

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "getAuthenticatedAccount",
    value: function getAuthenticatedAccount() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.tilReady();

              case 2:
                return _context19.abrupt("return", this.handleError(this.childIframeConnection.getAuthenticatedAccount()));

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "getDappKey",
    value: function getDappKey() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.tilReady();

              case 2:
                return _context20.abrupt("return", this.handleError(this.childIframeConnection.getLoginKey()));

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "getLoginKey",
    value: function getLoginKey() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.getLoginKey()` is deprecated. Use `authereum.getDappKey()` instead.');
                return _context21.abrupt("return", this.getDappKey());

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "getLoginKeyAuthSignature",
    value: function getLoginKeyAuthSignature() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.tilReady();

              case 2:
                return _context22.abrupt("return", this.handleError(this.childIframeConnection.getLoginKeyAuthSignature()));

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "getLoginKeyRestrictionData",
    value: function getLoginKeyRestrictionData() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.tilReady();

              case 2:
                return _context23.abrupt("return", this.handleError(this.childIframeConnection.getLoginKeyRestrictionData()));

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "getAccountAddress",
    value: function getAccountAddress() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.tilReady();

              case 2:
                return _context24.abrupt("return", this.handleError(this.childIframeConnection.getAccountAddress()));

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "getBalance",
    value: function getBalance() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.tilReady();

              case 2:
                return _context25.abrupt("return", this.handleError(this.childIframeConnection.getBalance()));

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    }
  }, {
    key: "getRpcUri",
    value: function getRpcUri() {
      return this.rpcUri;
    }
  }, {
    key: "getNetworkId",
    value: function getNetworkId() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.tilReady();

              case 2:
                return _context26.abrupt("return", this.handleError(this.childIframeConnection.getNetworkId()));

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      return this.provider;
    }
  }, {
    key: "handleError",
    value: function handleError(promise) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", promise.catch(function (err) {
                  _this3.emit('error', err);

                  if (err.message.includes('Login key is no longer active')) {
                    _this3.notifier.notify('error', 'Log back into Authereum to continue', {
                      timeout: 5000
                    });

                    _this3.logout();
                  } else {
                    _this3.notifier.notify('error', err.message, {
                      timeout: 5000
                    });
                  }
                }));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return this.iframeReady && this.cacheReady;
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(config) {
      this.setConfig(config);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        apiUri: this.apiUri,
        rpcUri: this.rpcUri,
        webUri: this.webUri,
        xsUri: this.xsUri,
        networkName: this.networkName,
        networkId: config_1.defaultConfig.networkId(this.networkName),
        disableNotifications: this.disableNotifications
      };
    }
  }, {
    key: "showWidget",
    value: function showWidget() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!enabled) {
        return this.hideWidget();
      }

      this._widgetEnabled = true;
      this.refreshWidget();
      return true;
    }
  }, {
    key: "hideWidget",
    value: function hideWidget() {
      this._widgetEnabled = false; // this.setIframePositionTop(this.getWindowHeight())
      // this.setIframePositionLeft(this.getWindowWidth())

      this.setIframeWidth(0);
      this.setIframeHeight(0);
      return true;
    }
  }, {
    key: "widgetEnabled",
    value: function widgetEnabled() {
      return this._widgetEnabled;
    }
  }, {
    key: "tilIframeReady",
    value: function tilIframeReady() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (this.iframeReady) {
                  _context28.next = 4;
                  break;
                }

                _context28.next = 3;
                return utils_1.wait(100);

              case 3:
                return _context28.abrupt("return", this.tilIframeReady());

              case 4:
                _context28.next = 6;
                return utils_1.wait(100);

              case 6:
                return _context28.abrupt("return", true);

              case 7:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "tilReady",
    value: function tilReady() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (this.isReady()) {
                  _context29.next = 4;
                  break;
                }

                _context29.next = 3;
                return utils_1.wait(100);

              case 3:
                return _context29.abrupt("return", this.tilReady());

              case 4:
                _context29.next = 6;
                return utils_1.wait(100);

              case 6:
                return _context29.abrupt("return", true);

              case 7:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
  }, {
    key: "emitReadyEvent",
    value: function emitReadyEvent() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.tilReady();

              case 2:
                if (!this.readyEmitted) {
                  _context30.next = 4;
                  break;
                }

                return _context30.abrupt("return");

              case 4:
                this.readyEmitted = true;
                this.emit('ready', {});

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "connectToChildIframe",
    value: function connectToChildIframe() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        var _this4 = this;

        var iframe;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return this.getOrCreateIframe();

              case 2:
                iframe = _context36.sent;
                this.iframeConnection = penpal_1.default.connectToChild({
                  iframe: iframe,
                  timeout: 60e3,
                  methods: {
                    onError: function onError(err) {
                      return __awaiter(_this4, void 0, void 0,
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee31() {
                        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                          while (1) {
                            switch (_context31.prev = _context31.next) {
                              case 0:
                                // TODO: button with link in toaster
                                // window.open('https://support.authereum.com/hc/en-us/articles/360036310154-How-can-I-enable-cookies-')
                                this.emit('error', err);
                                this.notifier.notify('error', err.message);

                              case 2:
                              case "end":
                                return _context31.stop();
                            }
                          }
                        }, _callee31, this);
                      }));
                    },
                    onLogout: function onLogout() {
                      return __awaiter(_this4, void 0, void 0,
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee32() {
                        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
                          while (1) {
                            switch (_context32.prev = _context32.next) {
                              case 0:
                                this.resetCache();
                                this.emit('logout', {});

                              case 2:
                              case "end":
                                return _context32.stop();
                            }
                          }
                        }, _callee32, this);
                      }));
                    },
                    onDappKeyExpired: function onDappKeyExpired(loginKeyAddress) {
                      return __awaiter(_this4, void 0, void 0,
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee33() {
                        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                          while (1) {
                            switch (_context33.prev = _context33.next) {
                              case 0:
                                if (loginKeyAddress === this.cachedLoginKeyAddress) {
                                  this.resetCache();
                                  this.emit('dappKeyExpired', loginKeyAddress);
                                }

                              case 1:
                              case "end":
                                return _context33.stop();
                            }
                          }
                        }, _callee33, this);
                      }));
                    },
                    login: function login() {
                      return __awaiter(_this4, void 0, void 0,
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee34() {
                        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                          while (1) {
                            switch (_context34.prev = _context34.next) {
                              case 0:
                                return _context34.abrupt("return", this.login());

                              case 1:
                              case "end":
                                return _context34.stop();
                            }
                          }
                        }, _callee34, this);
                      }));
                    },

                    /*
                    setWidgetPosition: (position: IPosition) => {
                      const { x, y } = position
                      this.iframeStyle.left = x
                      this.iframeStyle.top = y
                      // this.refreshWidget()
                    },
                     */
                    setWidgetSize: function setWidgetSize(size) {
                      var width = size.width,
                          height = size.height;
                      _this4.iframeStyle.width = width;
                      _this4.iframeStyle.height = height;

                      _this4.refreshWidget();
                    },
                    getWindowSize: function getWindowSize() {
                      return __awaiter(_this4, void 0, void 0,
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee35() {
                        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
                          while (1) {
                            switch (_context35.prev = _context35.next) {
                              case 0:
                                return _context35.abrupt("return", this.getWindowSize());

                              case 1:
                              case "end":
                                return _context35.stop();
                            }
                          }
                        }, _callee35, this);
                      }));
                    },
                    hideWidget: function hideWidget() {
                      _this4.hideWidget();
                    },
                    postMessage: function postMessage(data) {
                      return _this4.handlePostMessage(data);
                    }
                  }
                });
                this.iframeConnection.promise.then(function (child) {
                  _this4.iframeReady = true;
                  _this4.childIframeConnection = child;
                }) // TODO: only log error if not 'connection destroyed' error.
                // Eat error for now to not spam dapp.
                // tslint:disable-next-line
                .catch(function (err) {});

              case 5:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "getOrCreateIframe",
    value: function getOrCreateIframe() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (this.iframe) {
                  if (this.iframeConnection) {
                    this.iframeConnection.destroy();
                  }

                  this.iframe.remove();
                }

                return _context38.abrupt("return", new Promise(function (resolve) {
                  return __awaiter(_this5, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee37() {
                    var _this6 = this;

                    var id, iframe;
                    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
                      while (1) {
                        switch (_context37.prev = _context37.next) {
                          case 0:
                            id = "authereum__x-iframe--".concat(Date.now());
                            iframe = document.createElement('iframe');
                            iframe.id = id;
                            iframe.src = this.xsUri;
                            iframe.style.position = 'fixed';
                            iframe.style.bottom = '0';
                            iframe.style.right = '0';
                            iframe.style.width = '0';
                            iframe.style.height = '0';
                            iframe.style.border = '0';
                            iframe.style.background = 'transparent';
                            iframe.style.zIndex = '1';
                            iframe.setAttribute('frameborder', '0');
                            iframe.setAttribute('scrolling', 'no'); // iframe.style.outline = '1px solid red' // debug

                            this.iframe = iframe;
                            resolve(this.iframe);
                            _context37.next = 18;
                            return this.tilDomReady();

                          case 18:
                            document.body.appendChild(iframe);

                            iframe.onload = function () {
                              _this6.emit('iframeReady', {});

                              _this6.postVersionToChild();
                            };

                          case 20:
                          case "end":
                            return _context37.stop();
                        }
                      }
                    }, _callee37, this);
                  }));
                }));

              case 2:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
  }, {
    key: "postVersionToChild",
    value: function postVersionToChild() {
      return this.postMessageToChild({
        method: 'version',
        params: this.version()
      });
    }
  }, {
    key: "postMessageToChild",
    value: function postMessageToChild(data) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.tilReady();

              case 2:
                return _context39.abrupt("return", this.handleError(this.childIframeConnection.postMessage(data)));

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "handlePostMessage",
    value: function handlePostMessage(data) {
      try {
        var method = data.method,
            params = data.params;

        if (method === 'notification') {
          return this.handlePostMessageNotification(params);
        } else if (method === 'updateIdNotification') {
          return this.handlePostMessageUpdateIdNotification(params);
        } else if (method === 'updateNotification') {
          return this.handlePostMessageUpdateNotification(params);
        } else if (method === 'dismissNotification') {
          return this.handlePostMessageDismissNotification(params);
        } else if (method === 'log') {
          return this.handlePostMessageLog(params);
        }
      } catch (err) {// noop
      }
    }
  }, {
    key: "handlePostMessageNotification",
    value: function handlePostMessageNotification(data) {
      var id = data.id,
          type = data.type,
          message = data.message,
          timeout = data.timeout;

      if (!type) {
        type = 'success';
      }

      if (!timeout) {
        timeout = 5e3;
      }

      var notification = this.notifier.notify(type, message, {
        timeout: timeout
      });

      if (id) {
        this.notificationsMap[data.id] = notification;
      }
    }
  }, {
    key: "handlePostMessageUpdateIdNotification",
    value: function handlePostMessageUpdateIdNotification(data) {
      var id = data.id,
          oldId = data.oldId;
      this.notificationsMap[id] = this.notificationsMap[oldId];
    }
  }, {
    key: "handlePostMessageUpdateNotification",
    value: function handlePostMessageUpdateNotification(data) {
      var id = data.id,
          eventCode = data.eventCode,
          type = data.type,
          message = data.message,
          autoDismiss = data.autoDismiss;
      var notification = this.notificationsMap[id];

      if (notification) {
        notification.update({
          eventCode: eventCode,
          type: type,
          message: message,
          autoDismiss: autoDismiss
        });
      }
    }
  }, {
    key: "handlePostMessageDismissNotification",
    value: function handlePostMessageDismissNotification(data) {
      var id = data.id;
      var notification = this.notificationsMap[id];

      if (notification) {
        notification.dismiss();
      }
    }
  }, {
    key: "handlePostMessageLog",
    value: function handlePostMessageLog(data) {
      var type = data.type,
          message = data.message;

      if (!type) {
        type = 'log';
      }

      console[type](message);
    }
  }, {
    key: "getWindowSize",
    value: function getWindowSize() {
      return {
        width: this.getWindowWidth(),
        height: this.getWindowHeight()
      };
    }
  }, {
    key: "getWindowWidth",
    value: function getWindowWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
  }, {
    key: "getWindowHeight",
    value: function getWindowHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }
    /*
    public setIframePositionTop (y: number) {
    if (!this.iframe) return
    this.iframe.style.top = `${y}px`
    }
     */

  }, {
    key: "setIframePositionLeft",
    value: function setIframePositionLeft(x) {
      if (!this.iframe) return;
      this.iframe.style.left = "".concat(x, "px");
    }
  }, {
    key: "setIframeWidth",
    value: function setIframeWidth(width) {
      if (!this.iframe) return;
      this.iframe.style.width = "".concat(width, "px");
    }
  }, {
    key: "setIframeHeight",
    value: function setIframeHeight(height) {
      if (!this.iframe) return;
      this.iframe.style.height = "".concat(height, "px");
    }
  }, {
    key: "refreshWidget",
    value: function refreshWidget() {
      if (!this._widgetEnabled) return;
      var _this$iframeStyle = this.iframeStyle,
          top = _this$iframeStyle.top,
          left = _this$iframeStyle.left,
          width = _this$iframeStyle.width,
          height = _this$iframeStyle.height; // this.setIframePositionTop(top)
      // this.setIframePositionLeft(left)

      this.setIframeWidth(width);
      this.setIframeHeight(height);
    }
  }, {
    key: "loginKeyExists",
    value: function loginKeyExists() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40() {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.getLoginKey();

              case 2:
                return _context40.abrupt("return", !!_context40.sent);

              case 3:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "accountAddressExists",
    value: function accountAddressExists() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return this.getAccountAddress();

              case 2:
                return _context41.abrupt("return", !!_context41.sent);

              case 3:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "getAccountAdminKeyNonce",
    value: function getAccountAdminKeyNonce() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42() {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return this.tilReady();

              case 2:
                return _context42.abrupt("return", this.handleError(this.childIframeConnection.getAccountAuthKeyNonce()));

              case 3:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    }
  }, {
    key: "getAccountAuthKeyNonce",
    value: function getAccountAuthKeyNonce() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                console.warn('Deprecation notice: `authereum.getAccountAuthKeyNonce()` is deprecated. Use `authereum.getAccountAdminKeyNonce()` instead.');
                return _context43.abrupt("return", this.getAccountAdminKeyNonce());

              case 2:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "executeLoginKeyMetaTx",
    value: function executeLoginKeyMetaTx(tx, signOnly) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee44() {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return this.tilReady();

              case 2:
                return _context44.abrupt("return", this.handleError(this.childIframeConnection.executeLoginKeyMetaTx(serializeMessageObj(tx), signOnly)));

              case 3:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "loadLoginKey",
    value: function loadLoginKey(loginKey) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45() {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return this.tilReady();

              case 2:
                return _context45.abrupt("return", this.handleError(this.childIframeConnection.loadLoginKey(loginKey)));

              case 3:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
    }
  }, {
    key: "getOrCreateLoginKey",
    value: function getOrCreateLoginKey() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46() {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return this.tilReady();

              case 2:
                return _context46.abrupt("return", this.handleError(this.childIframeConnection.getOrCreateLoginKey()));

              case 3:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    }
  }, {
    key: "getAuthenticateUri",
    value: function getAuthenticateUri(loginKeyAddress) {
      // NOTE: slk = sign login key
      return this.webUri + '/?slk=' + encodeURIComponent(JSON.stringify({
        loginKey: {
          publicAddress: loginKeyAddress,
          // Convert to UTC to avoid local machine timezones
          expiresAt: moment_1.default().add(1, 'month').utc().unix()
        }
      })) + '&redirect_uri=' + this.redirectUri;
    }
  }, {
    key: "getSignWithAdminKeyUri",
    value: function getSignWithAdminKeyUri(message) {
      if (is_buffer_1.default(message)) {
        message = "0x".concat(message.toString('hex'));
      } // NOTE: sm = sign message


      return this.webUri + '/?sm=' + encodeURIComponent(JSON.stringify({
        message: message
      })) + '&redirect_uri=' + this.redirectUri;
    }
  }, {
    key: "openPopupOrRedirect",
    value: function openPopupOrRedirect(url) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        var _this7 = this;

        var child, isBlocked, err;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                this.emit('openPopup', {});
                child = window.open(url, 'Authereum', "toolbar=no,\n      location=no,\n      status=no,\n      menubar=no,\n      scrollbars=no,\n      resizable=no,\n      width=470,\n      height=640");
                isBlocked = child === null || child === undefined;

                if (!(isBlocked && !this.blockedPopupRedirect)) {
                  _context48.next = 9;
                  break;
                }

                err = new Error('Disable popup blocker and try again');
                this.notifier.notify('error', err.message, {
                  timeout: 5000
                });
                throw err;

              case 9:
                if (!isBlocked) {
                  _context48.next = 12;
                  break;
                }

                // NOTE: if window is blocked then resort to redirect
                window.location.href = url;
                return _context48.abrupt("return");

              case 12:
                child.focus();
                return _context48.abrupt("return", new Promise(function (resolve, reject) {
                  var interval = setInterval(function () {
                    return __awaiter(_this7, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee47() {
                      var _err;

                      return _regeneratorRuntime.wrap(function _callee47$(_context47) {
                        while (1) {
                          switch (_context47.prev = _context47.next) {
                            case 0:
                              if (child.closed) {
                                cleanUp();
                                _err = new Error('Window closed');
                                this.emit('error', _err);
                                this.emit('closePopup', {});
                                reject(_err);
                              }

                            case 1:
                            case "end":
                              return _context47.stop();
                          }
                        }
                      }, _callee47, this);
                    }));
                  }, 250);
                  var timeout = setTimeout(function () {
                    cleanUp();
                    child.close();
                    doneWithError(new Error('Timedout'));
                  }, 10 * 60 * 1000);

                  var cleanUp = function cleanUp() {
                    clearInterval(interval);
                    clearTimeout(timeout);

                    _this7.emit('closePopup', {});
                  };

                  var doneWithError = function doneWithError(err) {
                    cleanUp();
                    child.close();

                    _this7.emit('error', err);

                    reject(err);
                  };

                  var done = function done(result) {
                    cleanUp(); // NOTE: As of Chrome 77, this needs to be called twice if dev tools are open
                    // NOTE: https://support.google.com/chrome/thread/2241373?hl=en

                    child.close();
                    child.close();
                    resolve(result);
                  };

                  window.addEventListener('message', function (event) {
                    if (event.origin.includes(_this7.webUri)) {
                      if (event.data.login) {
                        done({
                          success: true
                        });

                        _this7.emit('login', {});

                        _this7.cachedIsAuthenticated = true;

                        if (_this7.redirectUri !== window.location.href) {
                          window.location.href = _this7.redirectUri;
                        }
                      } else if (event.data.result) {
                        done(event.data.result);

                        if (_this7.redirectUri !== window.location.href) {
                          window.location.href = _this7.redirectUri;
                        }
                      } else if (event.data.error) {
                        doneWithError(new Error(event.data.error));

                        if (_this7.redirectUri !== window.location.href) {
                          window.location.href = _this7.redirectUri;
                        }
                      }
                    }
                  });
                }));

              case 14:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    }
  }, {
    key: "signLoginKeyRequest",
    value: function signLoginKeyRequest(publicAddress) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49() {
        var url;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                url = this.getAuthenticateUri(publicAddress);
                return _context49.abrupt("return", this.openPopupOrRedirect(url));

              case 2:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    }
  }, {
    key: "tilDomReady",
    value: function tilDomReady() {
      return new Promise(function (resolve) {
        if (document.readyState !== 'loading') {
          resolve();
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            return resolve();
          });
        }
      });
    }
  }, {
    key: "version",
    value: function version() {
      return version_1.default;
    }
  }]);

  return Authereum;
}(eventemitter3_1.default);

exports.default = Authereum;

if (typeof window !== 'undefined') {
  window.Authereum = Authereum;
}